import { render, staticRenderFns } from "./Confidentiality.vue?vue&type=template&id=28fa4db4&scoped=true&lang=html"
import script from "./Confidentiality.vue?vue&type=script&lang=js"
export * from "./Confidentiality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa4db4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fa4db4')) {
      api.createRecord('28fa4db4', component.options)
    } else {
      api.reload('28fa4db4', component.options)
    }
    module.hot.accept("./Confidentiality.vue?vue&type=template&id=28fa4db4&scoped=true&lang=html", function () {
      api.rerender('28fa4db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Confidentiality.vue"
export default component.exports